<template>
  <div class="ab__list">
    <div v-if="(applyData.meta.abCount || applyData.meta.abCountAllReport) && showABTestTip" class="abtest_tip">
      <p>
        <i class="icon icon--heatmap-alarm"></i>
        <span class="tip" v-html="$t('ab.notification.originTraffic')"></span>
      </p>
      <button type="button" class="close" @click="setShowABTestTip(false)">
        <i class="icon icon--close14"></i>
      </button>
    </div>

    <div class="box-layout a-page__info clearfix">
      <div class="label">
        <p class="emphasis style1">A</p><span>Page</span>
      </div>

      <div class="info">
        <p class="name">{{ applyData.pageName }}</p>
        <p class="url">{{ applyData.url }}</p>
      </div>
    </div>

    <div class="box-layout b-page__list clearfix">
      <div class="label">
        <p class="emphasis style2">B</p><span>Pages</span>
      </div>

      <div class="button--wrap">
        <template v-if="!isShared">
          <!-- register button -->
          <div class="add" @mouseenter="showSPAAddToolTip(true)" @mouseleave="showSPAAddToolTip(false)">
            <ui-button v-if="!isFullTraffic && !isSPA && !isLogin"
                       primary
                       iconName="icon--plus-white"
                       :disabled="isAddDisabled || isDemo"
                       :to="{name: 'ab.option', params: routeParams}">{{ $t('common.addPage') }}</ui-button>
            <ui-button v-else-if="isSPA && !isLogin"
                       primary
                       iconName="icon--plus-white"
                       :disabled="isAddDisabled || isDemo"
                       :to="{name: 'ab.add.text', params: routeParams}">{{ $t('common.addPage') }}</ui-button>
  <!--           register button & traffic max -->
            <ui-button v-else
                       primary
                       iconName="icon--plus-white"
                       :disabled="isAddDisabled || isDemo"
                       @click="onAlertFullTraffic">{{ $t('common.addPage') }}</ui-button>
            <ui-tooltip class="tooltip" v-if="showSPAToolTip && isAddDisabled && !isFullTraffic" arrowCenter arrowBottom>
              <div v-html="$t('ab.tooltip')"></div>
            </ui-tooltip>
          </div>
          <!-- tracking -->
          <ui-button iconName="icon--tracking-code" class="btn__tracking-code"
                     @click="showTrackingCode = true">{{ $t('common.trackingCode.title') }}</ui-button>
        </template>
      </div>

      <ABtestListTable :abPageList="abPageList"/>
    </div>

    <!-- 트래킹 코드 -->
    <TrackingCodeConfirm
      v-if="showTrackingCode"
      @closePopup="showTrackingCode = false"
      :sid="applyData.sid"/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import TrackingCodeConfirm from '@/components/dashboard/TrackingCodeConfirm'
import ABtestListTable from '@/components/report-ab/ABtestListTable'
import AppDialog from '@/components/ui/AppDialog'
import UiButton from '@/components/ui/UiButton'
import { create } from 'vue-modal-dialogs'
import UiTooltip from '@/components/ui/UiTooltip.vue'

const alertFullTraffic = create(AppDialog, 'dialogType')

export default {
  components: {
    UiTooltip,
    TrackingCodeConfirm,
    ABtestListTable,
    UiButton
  },
  props: [
    'applyData',
    'abPageList'
  ],
  data () {
    return {
      showTrackingCode: false,
      creditEmpty: false,
      showSPAToolTip: false
    }
  },
  created () {
  },
  computed: {
    ...mapState([
      'userData',
      'showABTestTip',
      'isDemo'
    ]),
    ...mapGetters([
      'abUsedTraffic'
    ]),
    routeParams () {
      return {
        aid: this.$route.params.aid
      }
    },
    isFullTraffic () {
      return this.abUsedTraffic === 100
    },
    isShared () {
      return this.applyData.meta.shared
    },
    isSPA () {
      return this.applyData.meta.isSPA
    },
    isLogin () {
      return this.applyData.bLogin
    },
    isAddDisabled () {
      // console.log('endByAnalysisDate')
      return this.userData.creditEmpty || (this.applyData.state === 'endByPvLimit' || this.applyData.state === 'endByAnalysisDate') || (this.applyData.meta.isSPA && this.applyData.bLogin) || this.isFullTraffic
    }
  },
  methods: {
    ...mapMutations([
      'setShowABTestTip'
    ]),
    showSPAAddToolTip (value) {
      this.showSPAToolTip = value
    },
    onAlertFullTraffic () {
      alertFullTraffic('abReport.pageList.notExistingAvailableTraffic')
    }
  }
}
</script>

<style lang="scss">
.ab__list {
  margin-top: 30px;

  .abtest_tip {
    background-color: #f4e439;
    position: relative;
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: #2f2f2f;
    font-weight: 500;

    .tip {
      margin-left: 3px;
      & > strong {
        color: $brandColor;
      }
    }

    i {
      vertical-align: middle;
      margin: -2px 3px 0 7px;
    }

    .close {
      position: absolute;
      top: 9px;
      right: 6px;
      line-height: 15px;
      i {
        background-color: transparent;
      }
    }
  }

  .box-layout {
    width: 100%;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    margin-top: 30px;
    padding: 20px;
    box-sizing: border-box;

    .label {
      .emphasis {
        display: inline-block;
        width: 38px;
        height: 38px;
        line-height: 38px;
        border-radius: 5px;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        text-align: center;
        margin-right: 10px;

        &.style1 {
          background-color: #9fce12;
        }
        &.style2 {
          background-color: #1199af;
        }

        & + span {
          font-size: 16px;
          font-weight: 500;
          color: #2f2f2f;
        }
      }
    }
  }

  .a-page__info {
    display: flex;
    justify-content: flex-start;

    .label {
      white-space: nowrap;
    }

    .info {
      text-align: left;
      margin: 12px 0 12px 15px;

      .name {
        padding-left: 15px;
        font-size: 14px;
        line-height: 1.3;
        color: #2f2f2f;
        position: relative;
        font-weight: 500;

        &:before {
          position: absolute;
          transform: translateY(-50%);
          top: 9px;
          content: '';
          display: inline-block;
          width: 1px;
          height: 12px;
          left: 0;
          border-left: 1px solid #d7d7d7;
        }
      }
      .url {
        padding-left: 15px;
        font-size: 13px;
        color: #666;
        margin-top: 15px;
        font-weight: 500;
      }
    }
  }

  .b-page__list {
    position: relative;

    .title {
      font-size: 15px;
      font-weight: 600;
      line-height: 1;
      color: #2f2f2f;
    }

    .button--wrap {
      position: absolute;
      top: 20px;
      right: 20px;

      button {
        &.btn__tracking-code {
          margin-left: 5px;
        }
      }

      .add {
        position: relative;
        display: inline-block;

        i.bubble {
          bottom: 49px;
          left: 50%;
          transform: translateX(-50%);
        }

        .tooltip {
          position: absolute;
          white-space: pre;
          word-wrap: break-word;
        }
      }
    }

    .page__list {
      margin-top: 53px;
      height: 100px;
      background-color: #5c5c5c;
    }
  }
}
</style>
